import { Check, Stack } from '@fluentui/react';
import { Flex, Image } from '@fluentui/react-northstar';
import { Text } from 'office-ui-fabric-react';
import * as React from 'react';
import hubService from '../../api/services/hub';
import { HubFile } from '../../model';
import { MeetingContent } from '../../store/Meeting/types';
import styles from './index.module.scss';

export interface IMyMeetingFileItemProps {
    showMoreMenu?: boolean;
    id: number | undefined;
    item: MeetingContent;
    onItemClick: () => void;
}

export const MyMeetingFileItem = ({
        id,
        fileItem,
        onCheckedItemChange
    }: {
        showMoreMenu?: boolean;
        id: number | undefined;
        fileItem: MeetingContent;
        onItemClick: () => void;
        onCheckedItemChange: (id: number, file: HubFile, huShareUrl: string, flag: boolean) => void;
    }) => {

    const [item, setItem] = React.useState();
    const [checked, setChecked] = React.useState(false);
    const [hover, setHover] = React.useState(false);

    const othersAttr: any = {
        onMouseEnter : () => setHover(true),
        onMouseLeave : () => setHover(false)
    };

    React.useEffect(() => {
        if (id) {
            hubService.getFile(id).then((fileRes: any) => {
                fileRes.value.excerpt = fileRes.value.story.excerpt || fileRes.value.description;
                setItem(fileRes.value);
            });
        }
    }, [id]);

    if (!item)
        return null;
    const file: HubFile = item as unknown as HubFile;

    return (
        <Stack className={styles.container} {...othersAttr} onClick={() => { setChecked(!checked); onCheckedItemChange(file.id, file, fileItem.hubShareItemUrl, !checked) }}>
            <Flex className={styles.innerContainer} gap="gap.medium" padding="padding.medium">
                <Flex className={styles.thumbInnerContainer}>
                    <span className={file.shareStatus == "blocked" ? styles.reddot : styles.greendot}></span>
                    <Image className={styles.thumb} fluid src={file.thumbnail} />
                </Flex>
                <Flex className={styles.sidepanelDivContainer}>
                    <Flex className={styles.sidepanelSpanContainer} column >
                        <Text className={styles.sidepanelSpanTitle}>{file.description}</Text>
                        <Text className={styles.sidepanelSpanDesc}>{file.excerpt}</Text>
                    </Flex>
                </Flex>
                <Flex className={styles.checkContainer}>
                    <Flex className={styles.check} >
                        {(hover || checked) && <Check checked={checked} />}
                    </Flex>
                </Flex>
            </Flex>
            <Flex className={styles.seperator}></Flex>
        </Stack>
    )
};

export default MyMeetingFileItem;